import { useEffect } from "react";
import type { Editor as EditorCore } from "@tiptap/react";

import useDialogStore from "@store/useDialogStore";
import { LinkDialog } from "../components/LinkDialog";

export function useLinkDialog(editor: EditorCore) {
  const { openDialog, closeDialog } = useDialogStore();

  const handleOpen = ({ href, text }: { href: string; text: string }) => {
    openDialog(
      <LinkDialog
        href={href}
        text={text}
        onSave={(data) => {
          editor.chain().focus().setCustomLink(data).run();
        }}
      />
    );
  };

  const handleClose = () => closeDialog();

  useEffect(() => {
    if (!editor) return;

    editor.on("openLinkDialog", handleOpen);
    editor.on("closeLinkDialog", handleClose);

    return () => {
      editor.off("openLinkDialog");
      editor.off("closeLinkDialog");
    };
  }, [editor]);
}
